import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedPipesModule } from '../../shared-pipes/shared-pipes.module';
import { SimpleTabNavBarComponent } from './simple-tab-nav-bar.component';

@NgModule({
  imports: [CommonModule, SharedPipesModule],
  declarations: [SimpleTabNavBarComponent],
  exports: [SimpleTabNavBarComponent],
})
export class SimpleTabNavBarModule {}
